import React from 'react';
import PropTypes from 'prop-types';

import { withTheme } from '@material-ui/core/styles';
import SvgIcon from '@material-ui/core/SvgIcon';

const IconReferralSource = ({ theme, ...otherProps }) => (
  <SvgIcon {...otherProps} viewBox="0 0 86.972 90.118591">
    <path fill={theme.palette.primary.A400} d="m60.486-0.00020218-26.486 15.716l0.11985 53.957 26.366 15.645 26.486-15.716v-53.885l-26.486-15.717z" />
    <path fill={theme.palette.primary.A100} d="m0 31.207v40.414l30.27 17.962 18.919-11.226v-40.414l-15.135-8.9807v-13.471l3.783-2.2458-3.784-2.2452-34.053 20.207z" />
    <path fill={theme.palette.grey[100]} d="m60.486-0.00020218-26.486 15.716l26.486 15.717 26.486-15.717-26.486-15.716z" />
    <path fill={theme.palette.grey[100]} d="m41.6 15.226 18.918-11.226 18.919 11.226-18.919 11.226-18.918-11.226z" />
    <path fill={theme.palette.primary.A100} d="m34 16v53.885l26.486 15.716v-53.885l-26.486-15.716z" />
    <path fill={theme.palette.primary.A100} d="m30.3 49.226v40.414l18.918-11.226v-40.414l-18.918 11.226z" />
    <path fill={theme.palette.primary.A400} d="m54.7 17.547 1.9929 1.1825 1.9929-1.1825 1.9928 1.1825-1.9928 1.1827 1.9928 1.1823 5.9784-3.5475-1.9926-1.1826-1.9929 1.1826-1.9929-1.1826 1.9929-1.1827-1.9929-1.1823-5.9786 3.5476z" />
    <path fill={theme.palette.primary.A400} d="m45.384 17.471 15.135-8.9806v-4.4904l-18.919 11.226 3.7837 2.245z" />
    <path fill={theme.palette.primary.A100} d="m60.5 8.4902 15.138 8.9796 3.78-2.244l-18.918-11.226v4.4904z" />
    <g fill={theme.palette.primary.A400}>
      <path d="m11.3 78.923 18.918 11.196v-35.893l-18.918-11.226v35.923z" />
      <path d="m30.3 54.011v35.893l15.135-8.985v-35.919l-15.135 9.0108z" />
      <path d="m4.3241 40 2.5244 1.4979v2.9957l2.5243 1.4979v2.9957l-2.5243-1.498v2.9958l-2.5244-1.4978v-2.9957l-2.5241-1.4979v-2.9957l2.5241 1.4979v-2.9958z" />
      <path d="m37.8 22v4.4904l3.7837 2.2452v-4.4904l-3.7837-2.2452z" />
      <path d="m45.4 27v4.4904l3.7837 2.2452v-4.4904l-3.7837-2.2452z" />
      <path d="m53 31v4.4904l3.7837 2.2452v-4.4904l-3.784-2.245z" />
      <path d="m53 40v4.4904l3.7837 2.2452v-4.4904l-3.784-2.245z" />
      <path d="m53 49v4.4904l3.7837 2.2452v-4.4904l-3.784-2.245z" />
      <path d="m53 58v4.4906l3.7837 2.2452v-4.4904l-3.784-2.246z" />
      <path d="m53 67v4.4904l3.7837 2.2452v-4.4904l-3.784-2.245z" />
    </g>
    <g fill={theme.palette.primary.A100}>
      <path d="m64.3 33.245v4.4904l3.7837-2.2452v-4.4904l-3.7837 2.2452z" />
      <path d="m71.9 29.245v4.4904l3.7838-2.2452v-4.4904l-3.7838 2.2452z" />
      <path d="m79.4 24.245v4.4904l3.7837-2.2452v-4.4904l-3.7837 2.2452z" />
      <path d="m64.3 42.245v4.4904l3.7837-2.2452v-4.4904l-3.7837 2.2452z" />
      <path d="m71.9 38.245v4.4904l3.7838-2.2452v-4.4904l-3.7838 2.2452z" />
      <path d="m79.4 33.245v4.4904l3.7837-2.2452v-4.4904l-3.7837 2.2452z" />
      <path d="m64.3 51.245v4.4903l3.7837-2.2452v-4.4904l-3.7837 2.2453z" />
      <path d="m71.9 47.245v4.4906l3.7838-2.2454v-4.4904l-3.7838 2.2452z" />
      <path d="m79.4 42.245v4.4904l3.7837-2.2452v-4.4904l-3.7837 2.2452z" />
      <path d="m64.3 60.245v4.4904l3.7837-2.245v-4.4906l-3.7837 2.2452z" />
      <path d="m71.9 56.245v4.4904l3.7838-2.2452v-4.4904l-3.7838 2.2452z" />
      <path d="m79.4 51.245v4.4904l3.7837-2.2452v-4.4903l-3.7837 2.2451z" />
      <path d="m64.3 69.245v4.4904l3.7837-2.245v-4.4906l-3.7837 2.2452z" />
      <path d="m71.9 65.245v4.4904l3.7838-2.2452v-4.4904l-3.7838 2.2452z" />
      <path d="m79.4 60.245v4.4904l3.7837-2.2452v-4.4903l-3.7837 2.2451z" />
    </g>
    <path fill={theme.palette.grey[100]} d="m0 31.207 30.27 17.962 18.918-11.227-15.135-8.98v-13.472l3.784-2.2448-3.784-2.2452-34.053 20.207z" />
    <path fill={theme.palette.grey[100]} d="m7.5 31.716 22.702 13.472 15.136-8.969-11.352-6.748v-13.471l-26.486 15.716z" />
    <path fill={theme.palette.primary.A400} d="m11.284 33.962 22.702-13.472v-4.49l-26.486 15.716 3.7837 2.246z" />
    <path fill={theme.palette.grey[100]} d="m22.9 32.49 7.5673-4.4903 7.5676 4.4903v4.4904l-7.5677 4.4903-7.5673-4.4903v-4.4904z" />
    <path fill={theme.palette.primary.A100} d="m22.9 33v4.4904l7.5673 4.4905v-4.4905l-7.5673-4.4904z" />
    <path fill={theme.palette.primary.A400} d="m30.5 41.981 7.5676-4.4906v-4.4904l-7.5676 4.4904v4.4906z" />
  </SvgIcon>
);

IconReferralSource.propTypes = {
  theme: PropTypes.shape({
    palette: PropTypes.shape({
      primary: PropTypes.shape({
        A100: PropTypes.string.isRequired,
        A400: PropTypes.string.isRequired,
      }).isRequired,
      grey: PropTypes.shape({
        100: PropTypes.string.isRequired,
      }).isRequired,
    }).isRequired,
  }).isRequired,
};

export default withTheme()(IconReferralSource);



// WEBPACK FOOTER //
// ./src/components/icons/IconReferralSource.js